import React from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const Testimonials = ({ websiteData, testimonialsScrollRef, scroll, renderStars }) => {
  return (
    <div className="relative mt-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-purple-900 mb-4">Real Results, Real Stories</h2>
        <p className="text-gray-600 text-lg">See what our community has achieved with the PHYT method</p>
      </div>
      
      <div className="absolute right-0 top-3 hidden sm:flex space-x-2 z-10">
        <button 
          onClick={() => scroll(testimonialsScrollRef, 'left')} 
          className="p-3 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-purple-100"
          aria-label="Scroll left"
        >
          <ChevronLeft className="w-5 h-5 text-purple-700" />
        </button>
        <button 
          onClick={() => scroll(testimonialsScrollRef, 'right')} 
          className="p-3 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-purple-100"
          aria-label="Scroll right"
        >
          <ChevronRight className="w-5 h-5 text-purple-700" />
        </button>
      </div>
      
      <div 
        ref={testimonialsScrollRef}
        className="flex space-x-6 overflow-x-auto pb-6 snap-x snap-mandatory hide-scrollbar w-full max-w-full px-0"
      >
        {websiteData.testimonials.map((testimonial) => (
          <div 
            key={testimonial.id} 
            className="snap-start flex-none w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg bg-white border border-purple-100 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:translate-y-[-4px] p-6 group relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-purple-25 to-pink-25 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
            
            <div className="relative z-10">
              {/* Result badge */}
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-green-400 to-green-600 text-white text-xs font-bold py-1 px-3 rounded-full transform rotate-12">
                {testimonial.result}
              </div>
              
              {/* Rating */}
              <div className="mb-4">
                {renderStars(testimonial.rating)}
              </div>
              
              {/* Quote */}
              <blockquote className="text-gray-700 mb-4 italic leading-relaxed">
                "{testimonial.content}"
              </blockquote>
              
              {/* Author */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center text-white font-bold mr-3">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-purple-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">PHYT Client</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Custom CSS */}
      <style>{`
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }

        .bg-purple-25 {
          background-color: rgb(250, 248, 255);
        }
      `}</style>
    </div>
  );
};

export default Testimonials; 